import 'babel-polyfill';
import glob from 'glob'
import minimist from 'minimist'
import clone from 'git-clone'
import fs from 'fs'
import chalk from 'chalk'

var argv = minimist(process.argv.slice(2));
var Organized = {plugins:[]};

export default Organized;

export let config = {}

export let log = {
    success:(text) => {
        console.log(chalk.bold.green(text));
        console.log('');
    },
    danger:(text) => {
        console.log(chalk.bold.red(text));
        console.log('');
    },
    warning:(text) => {
        console.log(chalk.bold.yellow(text));
        console.log('');
    },
    info:(text) => {
        console.log(chalk.bold.cyan(text));
        console.log('');
    }
}

export let load = (index, item) => {
    Organized[index] = item;
}

export let installPackages = (packages) => {
    var child_process = require('child_process');

    (function install(modules, callback){
        if (modules.length == 0) {
            if (callback) callback(null);
            return;
        }

        var moduleName = modules.join(" ");

        child_process.exec('npm install ' + moduleName, {}, (error, stdout, stderr) => {
            process.stdout.write(stdout + '\n');
            process.stderr.write(stderr + '\n');

            if (error !== null)
                if (callback) callback(error);
            else
                if(callback) callback();
        });
    })(packages);
}

export let loadAll = async (folders,cb) => {
    let listFiles = async (dir) => {
        return new Promise((acc, rej) => {
            glob(dir, async (er, file) => {
                acc(file);
            });
        });
    }

    let getFiles = () => {
        return new Promise(async (acc, rej) => {
            let filesList = [];

            for(let i in folders){
                let dir = folders[i];
                let files = await listFiles(dir);

                files.forEach(el => {
                   filesList.push(el)
                });

                if(folders.length - 1 == i)
                    acc(filesList);
            }
        })
    }

    let files = await getFiles();
    let order = {};
    let listOfFiles = {};

    if(files.length > 0){
        for(let i in files){
            let file         = files[i];
            const routerFile = require(file);
            order[routerFile.name] = routerFile.dependencies;
            listOfFiles[routerFile.name] = routerFile;

            if(files.length - 1 == i){
               let orderOfPlugins = resolve(order);

               let listOfFunctions = {
                   cli:{},
                   generator:{}
               }

               for(let j in orderOfPlugins){
                    let plugin = orderOfPlugins[j];
                    let pluginClass = listOfFiles[plugin]

                    if(typeof pluginClass == 'object' && pluginClass.hasOwnProperty('default'))
                        await pluginClass.default(Organized);
                    else if(typeof pluginClass == 'function')
                        await pluginClass(Organized);

                    if((typeof pluginClass == 'object' || typeof pluginClass == 'function') && pluginClass.hasOwnProperty('generator')){
                        let generatorName = pluginClass.generator.name;
                        listOfFunctions['generator'][generatorName] = pluginClass.generator.action;
                    }

                    if((typeof pluginClass == 'object' || typeof pluginClass == 'function') && pluginClass.hasOwnProperty('cli')){
                        let generatorName = pluginClass.cli.name;
                        listOfFunctions['cli'][generatorName] = pluginClass.cli.action;
                    }

                    if(orderOfPlugins.length - 1 == j)
                        if(cb) cb(listOfFunctions);
               }
           }
        }
    }
    else{
        if(cb) cb();
    }
}

export let loadCli = async (folders,cb) => {

    let listFiles = async (dir) => {
        return new Promise((acc, rej) => {
            glob(dir, async (er, file) => {
                acc(file);
            });
        });
    }

    let getFiles = () => {
        return new Promise(async (acc, rej) =>{
            let filesList = [];

            for(let i in folders){
                let dir = folders[i];
                let files = await listFiles(dir);

                files.forEach(el => {
                   filesList.push(el);
                });

                if(folders.length - 1 == i)
                    acc(filesList);
            }
        })
    }

    let files = await getFiles();
    let order = {};
    let listOfFiles = {};

    for(let i in files){
        let file         = files[i];
        const routerFile = require(file);
        order[routerFile.name] = routerFile.dependencies;
        listOfFiles[routerFile.name] = routerFile;

        if(files.length - 1 == i){
           let orderOfPlugins = resolve(order);

           for(let j in orderOfPlugins){
                let plugin = orderOfPlugins[j];
                let cliService = process.argv[2];
                log.success(plugin);

                if(listOfFiles[plugin].hasOwnProperty('cli') && plugin == cliService)
                    await listOfFiles[plugin].cli(argv);

                if(orderOfPlugins.length - 1 == j)
                    if(cb) cb();
           }
       }
    }
}

export let loadNpmDependencies = async (folders,cb) => {
    let listFiles = async (dir) => {
        return new Promise((acc, rej) => {
            glob(dir, async (er, file) => {
                acc(file);
            });
        });
    }

    let getFiles = () => {
        return new Promise(async (acc, rej) => {
            let filesList = [];

            for(let i in folders){
                let dir = folders[i];
                let files = await listFiles(dir);

                files.forEach(el => {
                   filesList.push(el);
                });

                if(folders.length - 1 == i)
                    acc(filesList);
            }
        });
    }

    let files = await getFiles();
    let dependencies = [];

    for(let i in files){
        let file         = files[i];
        const routerFile = require(file);

        if(routerFile){
            routerFile.npm.forEach((pkg) => {
                dependencies.push(pkg);
            });
        }
    }

    installPackages(dependencies);
}

export let cloneRepositoryList = async (list, cb) => {
    const pkgJSON           = require(`${process.cwd()}/package.json`);
    const getRepositoryName = (name) => name.split("/")
    const repository        = list.shift()
    const gitSSHPattern     = /(.*?)@(.*?)\:(.*?)\/(.*?)\.git$/img
    const gitHTTPSPattern   = /^https:\/\//img
    let   repositoryUrl     = repository[0]
    const repositoryVersion = repository[1]
    let   repositoryName    = null

    if(gitSSHPattern.test(repositoryUrl)){
        try{

            let gitSplit = repositoryUrl.split("/")

            if(gitSplit.length > 1){
                let repositoryDotGit = gitSplit[1]
                    repositoryName   = repositoryDotGit.replace('.git','')
            }

        } catch(e) {
            console.log(e)
        }
    }
    else if(gitHTTPSPattern.test(repositoryUrl)){
        try{

            let repositoryList = repositoryUrl.replace(/https:\/\/(.*?)\/(.*?)$/,"$2").split("/")
                repositoryName = repositoryList[repositoryList.length - 1]

        } catch (e) {
            console.log(e)
        }
    }
    else{
        repositoryName    = getRepositoryName(repositoryUrl)[1];
        repositoryUrl     = `https://github.com/${repositoryUrl}`
    }

    clone(repositoryUrl, `${process.cwd()}/${pkgJSON.dekCLI.plugins}/${repositoryName}`, {checkout: repositoryVersion}, (err) => {
        if(err){
            log.warning(`Repositório ${repositoryUrl} já foi instalado anteriormente!`);
        }
        else{
            rmdirAsync(`${process.cwd()}/plugins/${repositoryName}/.git`, () =>{});
            log.success(`Repositório ${repositoryName} instalado com sucesso!`);
        }

        if(list.length > 0)
            cloneRepositoryList(list, cb);
        else
            if(cb) cb();
    })
}

export let cloneSkeleton = (name = null) => {
    let folder;

    if(name)
        folder = `${process.cwd()}/${name}`;
    else
        folder = `${process.cwd()}/dek-skeleton`;

    clone('https://github.com/vigiadepreco/dek-skeleton', folder, {checkout: 'master'},(err) => {
        if(err){
            log.warning(`Não foi possível iniciar a aplicação DEK`);
            console.log(err);
        }
        else{
            rmdirAsync(`${folder}/.git`, () =>{});
            log.warning(`Aplicação DEK iniciada com sucesso`)
        }
    })
}

const resolve = (graph) => {
    var sorted  = [], // sorted list of IDs ( returned value )
        visited = {}; // hash: id of already visited node => true

    // 2. topological sort
    Object.keys(graph).forEach(function visit(name, ancestors) {
        if (!Array.isArray(ancestors)) ancestors = [];
        ancestors.push(name);
        visited[name] = true;

        if(graph[name]){
            graph[name].forEach((dep) => {
                if (ancestors.indexOf(dep) >= 0)  // if already in ancestors, a closed chain exists.
                    throw new Error('Circular dependency "' +  dep + '" is required by "' + name + '": ' + ancestors.join(' -> '));

                // if already exists, do nothing
                if (visited[dep]) return;
                visit(dep, ancestors.slice(0)); // recursive call
            });
        }
        else{
            console.log(`ERROR: Não foi possível iniciar o serviço pois a dependência '${name}' não está instalada`);
            process.exit(1);
        }

        if(sorted.indexOf(name)<0) sorted.push(name);
    });

    return sorted;
}

const rmdirAsync = (path, callback) => {
	fs.readdir(path, (err, files) => {
		if(err) {
			// Pass the error on to callback
			callback(err, []);
			return;
		}

		var wait = files.length,
			count = 0,
			folderDone = (err) => {
    			count++;
    			// If we cleaned out all the files, continue
    			if( count >= wait || err) {
    				fs.rmdir(path,callback);
    			}
    		};

		// Empty directory to bail early
		if(!wait) {
			folderDone();
			return;
		}

		// Remove one or more trailing slash to keep from doubling up
		path = path.replace(/\/+$/,"");
		files.forEach((file) => {
			var curPath = path + "/" + file;

			fs.lstat(curPath, (err, stats) => {

				if( err ) {
					callback(err, []);
					return;
				}

				if( stats.isDirectory() )
					rmdirAsync(curPath, folderDone);
				else
					fs.unlink(curPath, folderDone);
			});
		});
	});
};
